import { Link } from "react-router-dom";
import { ArrowUpRight, Linkedin, Instagram, Twitter, Facebook } from "lucide-react";
import { SITE } from "@/constants/testIds";
import { SOCIAL_LINKS } from "@/config";

const SOCIALS = [
    { key: "linkedin", label: "LinkedIn", href: SOCIAL_LINKS.linkedin, Icon: Linkedin },
    { key: "instagram", label: "Instagram", href: SOCIAL_LINKS.instagram, Icon: Instagram },
    { key: "x", label: "X", href: SOCIAL_LINKS.x, Icon: Twitter },
    { key: "facebook", label: "Facebook", href: SOCIAL_LINKS.facebook, Icon: Facebook },
];

export const Footer = () => {
    return (
        <footer data-testid={SITE.footer} className="relative border-t border-brand-primary/10 bg-brand-bg overflow-hidden">
            <div className="container-x pt-24 pb-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
                    <div className="lg:col-span-7 space-y-6">
                        <p className="overline">Let&apos;s build the next chapter</p>
                        <h2 className="font-display h-display-lg">
                            Growth for the firms <br />
                            <span className="text-gradient-blue">moving markets.</span>
                        </h2>
                        <div className="pt-4">
                            <Link
                                to="/contact"
                                data-testid={SITE.footerEmail}
                                className="group inline-flex flex-wrap items-center gap-3 text-xl sm:text-2xl font-display text-brand-mist hover:text-brand-primary transition-colors break-all"
                            >
                                support@adxfusion.com
                                <ArrowUpRight className="shrink-0 w-6 h-6 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                            </Link>
                        </div>
                    </div>

                    <div className="lg:col-span-5 flex flex-col gap-10">
                        <div className="space-y-3">
                            <p className="overline">Pages</p>
                            <ul className="space-y-2 text-brand-frost">
                                <li><Link to="/" className="hover:text-brand-primary transition-colors">Index</Link></li>
                                <li><Link to="/who-we-are" className="hover:text-brand-primary transition-colors">Who we are</Link></li>
                                <li><Link to="/what-we-do" className="hover:text-brand-primary transition-colors">What we do</Link></li>
                                <li><Link to="/snapshot" className="hover:text-brand-primary transition-colors">Snapshot</Link></li>
                                <li><Link to="/blog" className="hover:text-brand-primary transition-colors">Blog</Link></li>
                                <li><Link to="/contact" className="hover:text-brand-primary transition-colors">Contact</Link></li>
                            </ul>
                        </div>
                        <div className="space-y-3">
                            <p className="overline">Follow</p>
                            <div className="flex items-center gap-3">
                                {SOCIALS.map(({ key, label, href, Icon }) => (
                                    <a
                                        key={key}
                                        href={href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label={label}
                                        data-testid={`social-${key}`}
                                        className="inline-flex items-center justify-center w-10 h-10 border border-brand-primary/30 text-brand-primary hover:text-brand-bg hover:bg-brand-primary hover:border-brand-primary transition-colors duration-300"
                                    >
                                        <Icon className="w-4 h-4" />
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-brand-primary/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm text-brand-primary/70">
                    <div className="flex items-center gap-4">
                        <Link to="/" aria-label="Adx Fusion — home" className="shrink-0">
                            <img src="/logo.png" alt="Adx Fusion" width="36" height="36" className="h-9 w-auto" loading="lazy" decoding="async" />
                        </Link>
                        <p>© 2024 Adx Fusion. A marketing partner for financial markets.</p>
                    </div>
                    <p className="font-mono text-xs uppercase tracking-widest">v1.0 · Built for forex brokers and financial brands</p>
                </div>
            </div>

            {/* Oversized wordmark */}
            <div className="pointer-events-none select-none">
                <div className="container-x">
                    <div className="font-display text-[18vw] leading-[0.85] tracking-tighter text-brand-primary/[0.04] -mb-6">
                        adxfusion
                    </div>
                </div>
            </div>
        </footer>
    );
};
